<framework-assets-image
  [assetFile]="assetFile"
  [size]="size"
  (loaded)="loaded.emit(true)"
  (errored)="errored.emit(true)"
>
  <framework-asset-image-content>
    @if (details) {
    <div class="left" (click)="openLink()">
      <div class="icon-title">
        <mat-icon [ngClass]="$safeNavigationMigration(project?.status?.id)">picture_in_picture</mat-icon>
        <p class="title">{{ project?.name }}</p>
      </div>
      <p class="subtitle">
        {{ project.productType ? project.productType.name + ' •' : null }} {{ project.publishDate | date : 'MMM dd,
        yyyy' }}
      </p>
    </div>
    }

    <div class="click" (click)="openLink()"></div>
  </framework-asset-image-content>
</framework-assets-image>
